/* Copyright (c) 2017 Backpack Health LLC */

import React, { FC } from 'react';
import { connect } from 'react-redux';

import './AddMenu.styles.scss';

import { CloseButton } from '../../../components/buttons/Buttons';

import { actions as systemModalActions } from '../../../redux/ducks/systemModal';

interface Props {
  closeMenu(): void;
}

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    closeMenu: () => {
      dispatch(systemModalActions.dismiss());
    },
  };
}


const AddMenu: FC<Props> = (props) => {
  return (
    <div className="cmp-add-menu">
      <div className="container">
        {props.children}
      </div>
      <div className="button-container">
        <CloseButton onClick={props.closeMenu}/>
      </div>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(AddMenu);
